import { Component, OnInit, ViewChild } from '@angular/core';
import { SatisfactionService } from '../../services/Satisfaction/satisfaction.service'
import Swal from 'sweetalert2'
import { array } from '@amcharts/amcharts4/core';
import { Router, ActivatedRoute } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-nav-logo',
  templateUrl: './nav-logo.component.html',
  styleUrls: ['./nav-logo.component.scss']
})
export class NavLogoComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  stars: number[] = [5];
  selectedValue: number = 4;
  selectedValue2 = [4, 4, 4, 4];
  remark = "";
  auth_data: string;
  verify_token = false;
  subject = [
    "ด้านเนื้อหา",
    "ด้านการออกแบบและการจัดรูปแบบเว็ปไซต์",
    "ด้านประโยชน์และการนำไปใช้งาน",
    "ด้านความถูกต้องและครบถ้วนของข้อมูล"
  ];
  ipAd: any;

  constructor(
    private SatisfactionService: SatisfactionService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.auth_data = JSON.parse(localStorage.getItem("access_token"));
    
    if (this.auth_data) {
      this.verify_token = true;
    }
    this.SatisfactionService.Get_ip_address().subscribe(
      res => {
        this.ipAd = res['ip'];
      }
    );

    const countEl = document.getElementById('count');

    // updateVisitCount();

    // function updateVisitCount() {
    //   fetch('https://api.countapi.xyz/update/florin-popcom/codepen/?amount=1')
    //     .then(res => res.json())
    //     .then(res => {
    //       countEl.innerHTML = res.value;
    //     })
    // }
  }

  ShowModal() {
    $('#warningModal').modal('show');
  }

  countStar(star) {
    this.selectedValue = star;

    if (this.selectedValue > 0) {
      $('#warningModal').modal('hide');
      sessionStorage.setItem('#warningModal', 'true');

    } else if (this.selectedValue == 0) {
      // $('#warningModal').modal('show');
      sessionStorage.setItem('#warningModal', 'false')

    }
  }
  // ข้อเสนอแนะ
  insertSatisfaction() {
    let body = [];
    for (let i = 0; i < 4; i++) {
      const data = {
        "titleTypeId": i + 1,
        "titleType": this.subject[i],
        "score": this.selectedValue2[i],
        "commect": "",
        "ipUser": this.ipAd,
      };
      body.push(data);
    }

    const data = {
      "titleTypeId": 5,
      "titleType": "ข้อเสนอแนะ",
      "score": 0,
      "commect": this.remark,
      "ipUser": this.ipAd,
    };
    body.push(data);

    this.SatisfactionService.AddSatisfaction(body).subscribe(
      res => {
        Swal.fire({
          icon: 'success',
          title: 'ขอบคุณสำหรับความคิดเห็นค่ะ',
          showConfirmButton: false,
          timer: 1500
        })
        this.selectedValue2 = [4, 4, 4, 4];
        this.remark = "";
        // this.closebutton.nativeElement.click();
      }
    );

  }

  insertSatisfaction_x() {
    let body = [];
    for (let i = 0; i < 4; i++) {
      const data = {
        "titleTypeId": i + 1,
        "titleType": this.subject[i],
        "score": 4,
        "commect": "",
        "ipUser": this.ipAd,
      };
      body.push(data);
    }

    const data = {
      "titleTypeId": 5,
      "titleType": "ข้อเสนอแนะ",
      "score": 0,
      "commect": this.remark,
      "ipUser": this.ipAd,
    };
    body.push(data);

    this.SatisfactionService.AddSatisfaction(body).subscribe(
      res => {
      }
    );
  }

  get_star(data) {
    this.selectedValue = data;
  }

  plus(data) {
    if (this.selectedValue2[data] < 4) {
      this.selectedValue2[data]++
    }
  }

  minus(data) {
    if (this.selectedValue2[data] > 1) {
      this.selectedValue2[data]--
    }
  }

  login_page() {
    this.router.navigate(["/Login"]);
  }

  logOut() {
    localStorage.removeItem('access_token');
    window.location.href = "./"
  }
  // user-management

}
